<template>
  <div style="height:100%;">
    <div class="col-12 list-wrapper" style="height:100%;">
      <file-card :files="files" :show-add-button="true" :patient-id="patient.patientId"></file-card>
    </div>
    <n-pagination v-if="totalPages > 0" :page-count="totalPages" v-model="pageNumber"></n-pagination>
  </div>
</template>

<script>
import FileCard from "../components/FileCard.vue";

export default {
  name: "FilesHistory",

  components: {
    FileCard,
  },

  data() {
    return {
      files: [],

      totalPages: 0,
      pageNumber: 1,
    };
  },

  async created() {
    this.getFiles();
  },

  computed: {
    patient() {
      return this.$store.state.patient;
    },
  },

  methods: {
    async getFiles() {
      let loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
      });
      try {
        let response = await this.$store.dispatch("getFiles", {
          query: {
            patientId: this.patient.patientId,
          },
          pageNumber: this.pageNumber,
        });

        this.files = response.data;
        this.totalPages = response.totalPages;
        loader.hide();
      } catch (e) {
        console.log(e);
        loader.hide();
      }
    },
  },

  watch: {
    pageNumber: function () {
      this.getFiles();
    },
  },
};
</script>

<style scoped>
.list-wrapper {
  height: 700px;
}

@media (max-height: 812px) {
  .list-wrapper {
    height: 620px;
  }
}
@media (max-height: 892px) {
  .list-wrapper {
    height: 740px;
  }
}
</style>
